import { Route, Switch } from 'react-router-dom';

import { ONBOARDING_BASE_URL } from './constants';
import { OnboardingRoutes } from './onboarding/OnboardingRoutes';

export const CreditCard = () => {
    return (
        <Switch>
            <Route path={ONBOARDING_BASE_URL}>
                <OnboardingRoutes />
            </Route>
        </Switch>
    );
};
